<template>
  <section id="skills" class="skills-container">
    <h2>Tech Stack</h2>
    <div class="skills-grid">
      <div class="skill-category">
        <h3>Frontend</h3>
        <div
          class="skill-item"
          v-for="skill in frontendSkills"
          :key="skill.name"
        >
          <div class="skill-header">
            <span class="skill-name">{{ skill.name }}</span>
            <span class="skill-level-text">{{ skill.levelText }}</span>
          </div>
          <div class="skill-bar">
            <div
              class="skill-level"
              :style="{ width: skill.level + '%' }"
            ></div>
          </div>
          <p class="skill-desc">{{ skill.desc }}</p>
        </div>
      </div>

      <div class="skill-category">
        <h3>Backend</h3>
        <div
          class="skill-item"
          v-for="skill in backendSkills"
          :key="skill.name"
        >
          <div class="skill-header">
            <span class="skill-name">{{ skill.name }}</span>
            <span class="skill-level-text">{{ skill.levelText }}</span>
          </div>
          <div class="skill-bar">
            <div
              class="skill-level"
              :style="{ width: skill.level + '%' }"
            ></div>
          </div>
          <p class="skill-desc">{{ skill.desc }}</p>
        </div>
      </div>

      <div class="skill-category">
        <h3>DevOps</h3>
        <div class="skill-item" v-for="skill in devopsSkills" :key="skill.name">
          <div class="skill-header">
            <span class="skill-name">{{ skill.name }}</span>
            <span class="skill-level-text">{{ skill.levelText }}</span>
          </div>
          <div class="skill-bar">
            <div
              class="skill-level"
              :style="{ width: skill.level + '%' }"
            ></div>
          </div>
          <p class="skill-desc">{{ skill.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SkillsSection",
  data() {
    return {
      frontendSkills: [
        {
          name: "React",
          level: 80,
          levelText: "중상",
          desc: "컴포넌트 기반 아키텍처를 이해하고 상태 관리를 활용한 SPA 개발 경험이 있습니다.",
        },
        {
          name: "Vue.js",
          level: 80,
          levelText: "중상",
          desc: "직관적인 문법을 바탕으로 포트폴리오 등 다양한 프로젝트를 빠르게 구축할 수 있습니다.",
        },
      ],
      backendSkills: [
        {
          name: "Spring Boot",
          level: 90,
          levelText: "상",
          desc: "JPA 기반의 비즈니스 로직 개발, RESTful API 서버 구축, JWT 인증/인가 구현에 능숙합니다.",
        },
        {
          name: "Spring Legacy (MVC)",
          level: 75,
          levelText: "중상",
          desc: "MyBatis 연동 및 XML 설정 방식의 프로젝트 유지보수 및 기능 개발이 가능합니다.",
        },
      ],
      devopsSkills: [
        {
          name: "AWS",
          level: 75,
          levelText: "중상",
          desc: "EC2, RDS, S3, Route 53, ELB를 활용하여 서비스 배포 및 인프라를 구성한 경험이 있습니다.",
        },
        {
          name: "Docker",
          level: 65,
          levelText: "중",
          desc: "애플리케이션을 컨테이너화하여 개발 환경의 일관성을 유지하고 배포를 단순화할 수 있습니다.",
        },
        {
          name: "Linux",
          level: 70,
          levelText: "중",
          desc: "CLI 환경에 익숙하며, 서버 설정 및 기본적인 쉘 스크립트 작성이 가능합니다.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.skills-container {
  padding: 100px 5%;
  background-color: var(--bg-color);
}
h2 {
  font-size: 2.5rem;
  margin-bottom: 50px;
  text-align: center;
}
.skills-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}
.skill-category {
  background-color: var(--bg-secondary-color);
  border: 1px solid var(--card-border-color);
  border-radius: 15px;
  padding: 30px;
  transition: all 0.3s ease;
}
.skill-category:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 30px var(--card-shadow-color);
}
.skill-category h3 {
  font-size: 1.5rem;
  margin-top: 0;
  margin-bottom: 25px;
  border-bottom: 1px solid var(--card-border-color);
  padding-bottom: 10px;
}
.skill-item {
  margin-bottom: 25px;
}
.skill-item:last-child {
  margin-bottom: 0;
}
.skill-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
}
.skill-name {
  font-family: "Fira Code", monospace;
  color: var(--text-primary-color);
}
.skill-level-text {
  font-size: 0.9em;
  color: var(--text-secondary-color);
}
.skill-bar {
  width: 100%;
  height: 8px;
  background-color: var(--card-border-color);
  border-radius: 4px;
}
.skill-level {
  height: 100%;
  background-color: var(--point-color);
  border-radius: 4px;
}
.skill-desc {
  font-size: 0.9em;
  color: var(--text-secondary-color);
  margin-top: 10px;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .skills-container {
    padding: 60px 5%;
  }
}
</style>
